export default "/images/ico-pdf.svg?9933468a956ff286655a626388ae2ff3";